import axios from "axios"
import { t } from "i18next"
import { get } from "lodash"
import { useMutation } from "react-query"
import { toast } from "react-toastify"
import axiosInstance from "../api/base"

export const UseFileDownload = () => {


    const downloadMutation = useMutation(({ link, withAccessToken }: { link: string, withAccessToken: boolean }) => {
        return axios.get(link, {
            responseType: 'blob'
        })
    }, {
        retry: 10,
        retryDelay: 10 * 1000 //each 10s retry to download
    })

    const download = async (link?: string, filename?: string, successMessage: string = 'pdfSuccess', errorMessage: string = 'error:generic', withAccessToken = false) => {
        if (!link) {
            toast('No link found', { type: 'warning' })
            return
        }

        try {
            let result = await downloadMutation.mutateAsync({ link, withAccessToken })
            try {
                const binaryData = result.data;
                const blob = new Blob([binaryData], { type: result.headers['content-type'] });

                // Generate a download URL for the Blob
                const url = window.URL.createObjectURL(blob);

                //Create an A tag and download
                const a = document.createElement('a')

                a.href = url

                if (filename) {
                    a.setAttribute('download', filename)
                } else {
                    let dispositionfile: string = get(result.headers, 'content-disposition', '')
                    if (dispositionfile) {
                        let splited = dispositionfile.split('filename=')
                        a.setAttribute('download', splited[1])
                    }
                }


                // Append the link to the document body 
                document.body.appendChild(a);

                a.click();

                // Remove the link element from the document
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                toast(t(successMessage), { type: 'success' })
            } catch (error) {
                toast(t(errorMessage), { type: 'error' })

            }
        } catch (error) {
            toast(t('error:generic'), { type: 'error' })

        }
    }


    return {
        download,
        isDownloading: downloadMutation.isLoading,
        isDownloadError: downloadMutation.isError
    }
}